var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 10,
    viewBox: "0 0 28 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4505_50898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4809 3.35143C14.465 4.611 15.6034 5.31384 16.461 5.73176C17.3422 6.16051 17.6381 6.43548 17.6346 6.81895C17.6281 7.40575 16.9318 7.66475 16.2803 7.67481C15.1435 7.69242 14.4826 7.3679 13.9571 7.12247L13.5476 9.03861C14.0748 9.28153 15.051 9.49339 16.0632 9.50269C18.4394 9.50269 19.994 8.32975 20.0024 6.51117C20.0117 4.20314 16.81 4.07539 16.8318 3.04376C16.8394 2.73095 17.1379 2.39714 17.7919 2.31226C18.1157 2.26939 19.0094 2.23658 20.0226 2.70317L20.4203 0.849263C19.8754 0.650857 19.1751 0.460872 18.3031 0.460872C16.0666 0.460872 14.4936 1.64978 14.4809 3.35143ZM24.2417 0.62056C23.8078 0.62056 23.4421 0.873652 23.2789 1.26204L19.8847 9.36651H22.2591L22.7316 8.06069H25.6331L25.9072 9.36651H28L26.1738 0.62056H24.2417ZM24.5738 2.98317L25.2591 6.26737H23.3824L24.5738 2.98317ZM11.6021 0.620668L9.73044 9.3664H11.9931L13.8638 0.62045L11.6021 0.620668ZM8.25486 0.620668L5.8998 6.5734L4.94714 1.51186C4.83536 0.946825 4.39392 0.62056 3.9037 0.62056H0.0539219L0 0.874528C0.790344 1.04603 1.68831 1.32264 2.23234 1.61861C2.56528 1.7994 2.66022 1.95745 2.76959 2.38708L4.57395 9.36651H6.965L10.6308 0.62056L8.25486 0.620668Z",
    fill: "url(#paint0_linear_4505_50898)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4505_50898",
    x1: 1287.27,
    y1: 27.6406,
    x2: 1313.44,
    y2: -900.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4505_50898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 9.07812,
    fill: "white",
    transform: "translate(0 0.460938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.efc36d0666590ff3710c423c1718dc07.svg";
export { ForwardRef as ReactComponent };